import React, { FC } from "react";
import { useTranslations } from "next-intl";
import { IShipment } from "@/types/apiResponse.types";
import { useTheme } from "@/context/Theme.context";
import { Theme } from "@/enums";
import { formatNumber } from "@/utils/formatNumber";

type Props = {
  item: IShipment;
};

const PaymentTaxDetails: FC<Props> = ({ item }) => {
  const t = useTranslations();
  const theme = useTheme();

  const priceField = theme === Theme.UZ ? "priceNational" : "priceUsd";

  return (
    <div className="absolute right-0 top-[25px] z-10 flex min-w-[200px] flex-col gap-2 rounded-lg border border-[#f9f9f9] bg-[#F9F9F9] p-2 shadow">
      <div className="flex justify-between text-xs">
        <span>{t("transportation_price")}: </span>
        <span className="whitespace-nowrap">
          {theme === Theme.UZ ? t("uzs") : t("usd")}{" "}
          {formatNumber(item?.[priceField] || 0)}
        </span>
      </div>
      <div className="flex justify-between text-xs">
        <span>
          {t("addon_services")}({t("courier")}):
        </span>
        {/* TODO: add later */}
        <span>{theme === Theme.UZ ? t("uzs") : t("usd")} 0</span>
      </div>
    </div>
  );
};

export default PaymentTaxDetails;
